module.exports = __webpack_public_path__ + "media/images/mail-da826bde.png";